var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class Kramer {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: '#',
                next: /~\d+@\s+OK/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        this.deviceTable = {
            '-L8YzD_lQCyddT8T4__k': {
                name: 'VP-778',
                commandType: 'ROUTE',
                routeLayer: '12',
            },
            '-L9BWZjCtA5wohoLrq9Z': {
                name: 'VP-558',
                commandType: 'ROUTE',
                routeLayer: '12',
            },
            '-LTwPOKHIesIXzoezjD3': {
                name: 'VP-445',
                commandType: 'ROUTE',
                routeLayer: '12',
            },
            '-LbxHa_WeKISTdApmweq': {
                name: 'VS-622DT',
                commandType: 'ROUTE',
                routeLayer: '1',
            },
            '-NN9Jkdj8VBADz1lcyzw': {
                name: 'VP-440X',
                commandType: 'ROUTE',
                routeLayer: '1',
            },
            '-M8fG-uJkWQsRogMZ4OD': { name: 'VS-44H2A', commandType: 'VID' },
            '-MKKz6UL1S6S1ngVv0lb': { name: 'VP-774A', commandType: 'Y' },
            '-ML9TX7ITE-hJ5quZV0L': { name: 'VP-773A', commandType: 'Y' },
            '-NPxiWjjmyPEedPiWMRI': { name: 'VS-42UHD', commandType: 'ROUTE', routeLayer: '1' },
            '-NQVDU_Xb1kbk0yM4Uce': { name: 'VS-62HA', commandType: 'ROUTE', routeLayer: '1' },
            '-Ni5pIn6LR9OLat4s7kT': { name: 'VP-427X2', commandType: 'ROUTE', routeLayer: '1' },
            '-ODRK2Bllrj6VqTyXIW1': {
                name: 'SWT3-31-HU',
                commandType: 'ROUTE',
                routeLayer: '1',
                usbRouteLayer: '5',
            },
        };
        this.commandType = 'ROUTE';
        this.routeLayer = '1';
        this.usbRouteLayer = '5';
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#VERSION?`, /~\d+@VERSION\s+8?(.+)/i, tags);
                return match[1];
            }),
        };
        // Some Kramer products support independent routing of USB devices to hosts.
        this.usbHost = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#ROUTE? ${this.usbRouteLayer},1`, new RegExp(`~\\d+@ROUTE\\??\\s+${this.usbRouteLayer},(\\d+),(\\d+)|ERR`, 'i'), tags);
                return match[2];
            }),
            set: (value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(
                // ROUTE layer, output, input
                `#ROUTE ${this.usbRouteLayer},1,${value}`, new RegExp(`~\\d+@ROUTE\\??\\s+${this.usbRouteLayer},(\\d+),(\\d+)|ERR`, 'i'), tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                return match[2];
            }),
            asyncHandlers: [
                {
                    regExp: /~\d+@ROUTE\??\s+5,(\d+),(\d+)/i,
                    callback: (match) => {
                        this.state.usbHost.update(match[2]);
                    },
                },
            ],
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const match = yield this.socket.send(`#ROUTE? ${this.usbRouteLayer},1`, new RegExp(`~\\d+@ROUTE\\??\\s+${this.usbRouteLayer},(\\d+),(\\d+)|ERR`, 'i'), ['usbControl']);
                    return match[2] !== undefined;
                }
                catch (err) {
                    return false;
                }
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.commandType === 'VID') {
                    const match = yield this.socket.send(`#VID? ${key}`, /~\d+@VID\s+(\d+)>(\d+)|ERR\s+\d+/i, tags);
                    if (match[1])
                        return match[1];
                }
                else if (this.commandType === 'Y') {
                    const match = yield this.socket.send(`#Y 1,120,0`, /[YZ]\s+\d+[\s,]120[\s,](\d+)|ERR\s+\d+|-1/i, tags);
                    if (match[1])
                        return match[1];
                }
                else {
                    const match = yield this.socket.send(`#ROUTE? 1,${key}`, /~\d+@ROUTE\??\s+(?:\d+,(\d+),(\d+)|ERR)/i, tags);
                    if (match[2])
                        return match[2];
                }
                return this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                // Command syntax is: #VID input>output or #ROUTE layer,output,input or #Y 0 120 input 0
                if (this.commandType === 'VID') {
                    const match = yield this.socket.send(`#VID ${value}>${key}`, /~\d+@VID\s+(\d+)>(\d+)|ERR/i, tags);
                    if (match[1])
                        return match[1];
                }
                else if (this.commandType === 'Y') {
                    const match = yield this.socket.send(`#Y 0,120,${value},0`, /[YZ]\s+\d+[\s,]120[\s,](\d+)|ERR|-1/i, tags);
                    if (match[1])
                        return match[1];
                }
                else {
                    const match = yield this.socket.send(`#ROUTE ${this.routeLayer},${key},${value}`, /~\d+@ROUTE\s+(?:\d+,(\d+),(\d+)|ERR)/i, tags);
                    if (match[2])
                        return match[2];
                }
                return this.state.videoMatrixRoutes.values[key];
            }),
        };
        // polling
        this.polls = [{ intervalMs: 3000, controls: ['videoMatrixRoutes'] }];
    }
    // phase callbacks
    onConfigure(config) {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            // Specify the video switching command type from the table rather than from the actual model
            // to provide more flexibility in the field to force a command type based on selected model.
            this.commandType = this.deviceTable[(_a = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _a !== void 0 ? _a : ''].commandType;
            this.routeLayer = (_d = (_c = this.deviceTable[(_b = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _b !== void 0 ? _b : '']) === null || _c === void 0 ? void 0 : _c.routeLayer) !== null && _d !== void 0 ? _d : '1';
            this.usbRouteLayer = (_g = (_f = this.deviceTable[(_e = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _e !== void 0 ? _e : '']) === null || _f === void 0 ? void 0 : _f.usbRouteLayer) !== null && _g !== void 0 ? _g : '5';
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
Kramer.driverType = 'socketDriver';
Kramer.key = '-L8YyugCsWnrjhcTC957';
Kramer.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
};
Kramer.socketOptions = [
    Object.assign(Object.assign({}, Kramer.baseSocketOptions), { port: 5000 }),
    Object.assign(Object.assign({}, Kramer.baseSocketOptions), { port: 4999 }),
];
